package org.moxultimate.topwithmox.apps.data

import kotlinx.serialization.Serializable

/**
 * AppsTagResponse
 * Maps the backend AppsTagEntity returned by GET /apps-tag.
 */
@Serializable
data class AppsTagResponse(
    val id: Long,
    val tag: String? = null,
)
